import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { API_CONFIG } from '../shared/constants/api';
import { useTranslation } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';
import logo from '../logo.svg';
import './Auth.css';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError(t('profile.newPasswordMismatch'));
      return;
    }

    if (password.length < 6) {
      setError(t('profile.newPasswordTooShort'));
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_CONFIG.BASE_URL}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });

      const data = await res.json();

      if (res.ok) {
        setSuccess(true);
      } else {
        setError(data.error || t('auth.resetPassword.invalidToken'));
      }
    } catch {
      setError(t('common.networkError'));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <img src={logo} alt="Monnaify Logo" className="auth-logo" />
          <div className="error-message">{t('auth.resetPassword.invalidToken')}</div>
          <div className="auth-link">
            <Link to="/login">{t('auth.resetPassword.backToLogin')}</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-language-switcher">
        <LanguageSwitcher />
      </div>
      <div className="auth-box">
        <img src={logo} alt="Monnaify Logo" className="auth-logo" />
        <h1>{t('auth.resetPassword.title')}</h1>
        <p className="auth-subtitle">{t('auth.resetPassword.subtitle')}</p>

        {success ? (
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <p style={{ color: '#444', lineHeight: 1.6 }}>{t('auth.resetPassword.successMessage')}</p>
            <div className="auth-link" style={{ marginTop: 24 }}>
              <Link to="/login">{t('auth.resetPassword.backToLogin')}</Link>
            </div>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="password">{t('auth.resetPassword.password')}</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder={t('auth.resetPassword.passwordPlaceholder')}
                  disabled={loading}
                  minLength={6}
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">{t('auth.resetPassword.confirmPassword')}</label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  placeholder={t('auth.resetPassword.confirmPasswordPlaceholder')}
                  disabled={loading}
                  minLength={6}
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? t('auth.resetPassword.loading') : t('auth.resetPassword.submit')}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
